












import {Vue, Component} from 'vue-property-decorator';

@Component({
    name: 'ScrollUpButton',
})
export default class ScrollUpButton extends Vue {
    public windowY: number = 0;
    private windowYLimit: number = 800;

    public get show(): boolean {
        return this.windowY >= this.windowYLimit;
    }

    public created(): void {
        this.getWindowYpx();
    }

    public scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    private getWindowYpx(): void {
        window.addEventListener('scroll', () => {
            this.windowY = window.scrollY;
        });
    }

}
